import { createSelector } from 'reselect';
import { ArsenalArmyNewView } from './view/ArsenalArmyNewView';
import { getArsenalArmyState } from '../selector/getArsenalArmyState';

export const ArsenalArmyNewPresenter = createSelector(
  [getArsenalArmyState],
  (arsenalArmyState): ArsenalArmyNewView => {
    return new ArsenalArmyNewView({
      isLoading: arsenalArmyState.isLoading,
      canSubmit: !arsenalArmyState.isLoading,
    });
  },
);
